import { useSelectedVehicle } from "../context/vehicle.context";

const VehicleImage = (options)=>{
    const { selVehData } = useSelectedVehicle();

    console.log("Vehicle Image options: ", options);
    console.log("Vehicle Data: ", selVehData);

    return (
        <div className="vehicle-image">
            <img src={options.image} alt="Vehicle" />
            {selVehData.kills.mobility && <img className="pulsate" src={options.imageMobKill} alt="Vehicle" />}
            {selVehData.kills.weapon && <img className="pulsate" src={options.imageWpnKill} alt="Vehicle" />}
            {selVehData.kills.comms && <img className="pulsate" src={options?.imageCommsKill} alt="Vehicle" />}
            {selVehData.kills.total && <img className="pulsate" src={options?.imageTotalKill} alt="Vehicle" />}
        </div>
    )

}

export default VehicleImage;